import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import SignInForm from './index';
import validate from './validate';
import { submit } from '../../actions';

export default compose(
  reduxForm({
    form: 'portalSignIn',
    validate,
  }),
  connect(null, { submit })
)(SignInForm);
